import React, { useCallback, useEffect, useState } from 'react';
import { IRoleListProps } from './RolesForUserList.types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import {
  IActivePermissionsDetails,
  IRoleForUser,
} from '../../../services/rolesAndPermissions/rolesAndPermissions.types';
import { useStyles } from './RolesForUserList.styles';
import TooltipOne from '../../TooltipOne/TooltipOne.component';
import DefaultRoleIcon from '../../../assets/icons/default-role.svg';
import { Collapse, ListItemButton } from '@mui/material';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import CheckIcon from '@mui/icons-material/Check';
import { getUserRolesActivePermissions } from '../../../services/rolesAndPermissions/rolesAndPermissions.service';
import { useLayoutContext } from '../../../Context/Layout.context';
import { AxiosResponse } from 'axios';
import SwitchOne from '../../SwitchOne/SwitchOne.component';

export const RolesForUserList: React.FC<IRoleListProps> = ({
  roles: roles,
  onToggleRolesActivity: onTogglePermissionActivity,
}) => {
  const classes = useStyles();

  const [openPermissions, setOpenPermissions] = React.useState<string | undefined>(undefined);
  const [rolePermissions, setRolePermissions] = useState<IActivePermissionsDetails[]>();

  const { showLoader, openAlert } = useLayoutContext();

  const getRolePermission = useCallback((itemId) => {
    setRolePermissions([]);
    showLoader(true);
    getUserRolesActivePermissions(itemId)
      .then(
        (response: AxiosResponse<IActivePermissionsDetails[]>) => {
          setRolePermissions(response.data);
        },
        () => {
          openAlert('get_error');
        },
      )
      .finally(() => {
        showLoader(false);
      });
  }, []);

  useEffect(() => {
    if (openPermissions !== undefined) {
      getRolePermission(openPermissions);
    }
  }, []);

  const handleClick = (itemId: string, clickedItemID: string | undefined) => {
    if (itemId === clickedItemID) {
      setOpenPermissions(undefined);
    } else {
      setOpenPermissions(itemId);
      getRolePermission(itemId);
    }
  };

  return (
    <div className={classes.scrollBox}>
      {roles.length ? (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {roles.map((role: IRoleForUser) => {
            return (
              <React.Fragment key={role.id}>
                {role.isDefaultRole && !role.isUserAssignedToRole ? (
                  ''
                ) : (
                  <ListItem key={role.id} className={classes.listItem} disablePadding={true}>
                    <ListItemText
                      primary={
                        <>
                          <div className={classes.roleName}>
                            <div>
                              {role.roleName}
                              {role.isDefaultRole ? (
                                <TooltipOne title="Rola domyślna" placement="top">
                                  <div className={classes.iconCircle}>
                                    <img
                                      className={classes.defaultRoleIcon}
                                      src={DefaultRoleIcon}
                                      aria-label="Rola domyślna"
                                      alt="ikona rola domyślna"
                                    />
                                  </div>
                                </TooltipOne>
                              ) : (
                                ''
                              )}
                            </div>
                            {role.isDefaultRole && role.isUserAssignedToRole ? (
                              <SwitchOne
                                disableRipple
                                disabled
                                defaultChecked
                                color={'primary'}
                                inputProps={{ 'aria-label': `Zmień aktywność roli "${role.roleName}"`, 'aria-disabled': 'true' }}
                              />
                            ) : (
                              <SwitchOne
                                disableRipple
                                checked={role.isUserAssignedToRole}
                                color={'primary'}
                                onChange={() => onTogglePermissionActivity(role.id)}
                                inputProps={{ 'aria-label': `Zmień aktywność roli "${role.roleName}"` }}
                              />
                            )}
                          </div>
                          <div className={classes.roleDescription}>
                            <div className={classes.roleDescriptionTitle}>Opis: </div>
                            <div>{role.roleDescription}</div>
                          </div>
                          <ListItemButton
                            onClick={() => handleClick(role.id, openPermissions)}
                            className={classes.rolePermissions}
                          >
                            <ListItemText primary="Uprawnienia:" />
                            {openPermissions === role.id ? <ExpandLess /> : <ExpandMore />}
                          </ListItemButton>
                          <Collapse in={openPermissions === role.id} timeout="auto" unmountOnExit>
                            {rolePermissions !== undefined && rolePermissions.length ? (
                              <List component="div" disablePadding>
                                {rolePermissions.map((permission: IActivePermissionsDetails) => {
                                  return (
                                    <ListItem key={permission.id} disablePadding={true}>
                                      <ListItemText
                                        primary={
                                          <>
                                            <li style={{ display: 'flex' }}>
                                              <CheckIcon fontSize="medium" style={{ color: 'rgb(60, 65, 154)' }} />
                                              <span style={{ marginLeft: '10px' }}>{permission.description}</span>
                                            </li>
                                          </>
                                        }
                                      />
                                    </ListItem>
                                  );
                                })}
                              </List>
                            ) : (
                              <div className={classes.emptyMessage}>Brak przypisanych uprawnień</div>
                            )}
                          </Collapse>
                        </>
                      }
                    />
                  </ListItem>
                )}
              </React.Fragment>
            );
          })}
        </List>
      ) : (
        <div className={classes.emptyMessage}>Brak rekordów do wyświetlenia</div>
      )}
    </div>
  );
};
